import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Wordmark from "../Wordmark.jsx";
// import ThemeSwitch from "../../common/ThemeSwitch/ThemeSwitch.jsx";

// Nine links: the full bar shows from lg (1024px) with nowrap labels; below
// that the hamburger menu takes over (it used to switch at md, which wrapped
// the bar onto 2-3 lines once the calculators were added).
const NAV_LINKS = [
  { to: "/", label: "Home", end: true },
  { to: "/how-it-works", label: "How it works" },
  { to: "/rates", label: "Rates" },
  // The calculators are transactional tools that end in sign-up, so they sit in
  // the main nav rather than only the footer. Short labels keep the bar on one line.
  { to: "/form-2290-tax-calculator", label: "Tax calculator" },
  { to: "/form-2290-due-date-calculator", label: "Due dates" },
  { to: "/pricing", label: "Pricing" },
  { to: "/faq", label: "FAQ" },
  // Labelled "Blog" to match the /blog URL and what people actually scan a nav
  // for. Load-bearing for SEO beyond the wording: react-snap discovers pages by
  // crawling links from "/", so an unlinked /blog would never be prerendered -
  // and an unlinked section earns no internal-link equity either.
  { to: "/blog", label: "Blog" },
  { to: "/about", label: "About" },
];

const navCls = ({ isActive }) =>
  [
    "text-[14px] font-semibold no-underline transition-colors whitespace-nowrap",
    isActive ? "text-[var(--ink)]" : "text-[var(--muted)] hover:text-[var(--ink)]",
  ].join(" ");

const PublicHeader = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="sticky top-0 z-30 bg-[var(--panel)] border-b border-[var(--line)]">
      <div className="max-w-[1180px] mx-auto flex items-center justify-between gap-4 px-[22px] py-3">
        <Link
          to="/"
          className="inline-flex items-center no-underline text-[var(--ink)]"
        >
          <Wordmark size="md" />
        </Link>

        <nav className="hidden lg:flex items-center gap-3 xl:gap-6">
          {NAV_LINKS.map((l) => (
            // "Home" only from xl: between 1024 and 1279px there isn't room for
            // nine links plus both buttons, and the logo already links home.
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={(st) => `${navCls(st)}${l.to === "/" ? " hidden xl:inline" : ""}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          {/* <ThemeSwitch /> */}
          <Link
            to="/login"
            className="text-sm font-semibold no-underline whitespace-nowrap text-[var(--ink)] px-[14px] py-[9px] rounded-[10px] border border-[var(--line-2)] bg-[var(--panel)] hover:bg-[var(--panel-2)]"
          >
            Sign in
          </Link>
          <Link
            to="/login?tab=up"
            className="text-sm font-semibold no-underline whitespace-nowrap text-[var(--accent-ink)] bg-[var(--accent-fill)] px-[16px] py-[9px] rounded-[10px] hover:brightness-[1.06]"
          >
            Get started free
          </Link>
        </div>

        <button
          onClick={() => setOpen((o) => !o)}
          className="lg:hidden border border-[var(--line-2)] rounded-[10px] p-2 bg-[var(--panel)] text-[var(--ink)]"
          aria-label="Toggle menu"
        >
          {open ? <X size={19} /> : <Menu size={19} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[var(--line)] px-[22px] py-3 flex flex-col gap-3.5">
          {NAV_LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} className={navCls} onClick={() => setOpen(false)}>
              {l.label}
            </NavLink>
          ))}
          {/* <div className="flex items-center gap-3 pt-2 border-t border-[var(--line)]">
            <ThemeSwitch />
          </div> */}
          <div className="flex gap-2.5">
            <Link
              to="/login"
              className="flex-1 text-center text-sm font-semibold no-underline text-[var(--ink)] px-[14px] py-[10px] rounded-[10px] border border-[var(--line-2)] bg-[var(--panel)]"
            >
              Sign in
            </Link>
            <Link
              to="/login?tab=up"
              className="flex-1 text-center text-sm font-semibold no-underline text-[var(--accent-ink)] bg-[var(--accent-fill)] px-[16px] py-[10px] rounded-[10px]"
            >
              Get started free
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default PublicHeader;
